import Cookies from 'js-cookie';
import PropTypes from 'prop-types';
import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import { getCredentials } from '../../../actions/hub/hubAuthPagesActions';
import { setStaffToken } from '../../../api/auth';
import ErrorBlock from '../../../common/ErrorBlock';
import InPageLoader from '../../../common/InPageLoader';
import PageError from '../../../common/PageError';
import AuthPageLayout from '../../../common/hub/AuthPageLayout';
import { LOCALSTORAGE_SSO_HANDOFF_SESSION } from '../../../util/constants';
import { PATH_HUB_HOME } from '../../../util/pagePath';
import { seedCognitoSession } from '../../../util/seedCognitoSession';

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const isQueryParamValid = (value) => {
  return value !== '' && value !== null;
};

const HubStaffLoginPage = ({ errorMsg, isClockSkewDetected, checkUserStatus }) => {
  const history = useHistory();
  const [showPageError, setShowPageError] = useState(false);

  const query = useQuery();
  useEffect(() => {
    const userName = query.get('UserName');
    const staffToken = query.get('staffToken');
    const accessToken = query.get('AccessToken');
    const idToken = query.get('IdToken');
    const refreshToken = query.get('RefreshToken');

    if (
      isQueryParamValid(userName) &&
      isQueryParamValid(staffToken) &&
      isQueryParamValid(accessToken) &&
      isQueryParamValid(idToken) &&
      isQueryParamValid(refreshToken)
    ) {
      try {
        seedCognitoSession({
          idToken,
          accessToken,
          refreshToken,
        });
        // Staff login is hub-owned and includes a refresh token.
        localStorage.removeItem(LOCALSTORAGE_SSO_HANDOFF_SESSION);

        checkUserStatus({
          staffToken,
          onSuccess: () => {
            Cookies.set('staffToken', staffToken);
            setStaffToken(staffToken);
            history.push(PATH_HUB_HOME);
          },
        });
      } catch (e) {
        setShowPageError(true);
      }
    } else {
      setShowPageError(true);
    }
  }, [query, setShowPageError, checkUserStatus, history]);

  if (isClockSkewDetected) {
    return <PageError activePage="redirect-clock-skew-handle" />;
  }

  return (
    <Fragment>
      {!showPageError && errorMsg === '' && <InPageLoader />}
      {showPageError && <PageError activePage="hub-staff-login-page" />}
      {!showPageError && (
        <AuthPageLayout
          title="Log into the Cluey Hub as a Cluey staff"
          subtitle="View users' sessions, enrolments and account settings."
        >
          <ErrorBlock errorMsg={errorMsg} />
        </AuthPageLayout>
      )}
    </Fragment>
  );
};

HubStaffLoginPage.propTypes = {
  errorMsg: PropTypes.string,
  isClockSkewDetected: PropTypes.bool.isRequired,
  checkUserStatus: PropTypes.func.isRequired,
};

HubStaffLoginPage.defaultProps = {
  errorMsg: '',
};

export default connect(
  (state) => {
    return {
      errorMsg: state.ui.apiState.hubAuthPage.errorMsg,
      isClockSkewDetected: state.login.isClockSkewDetected,
    };
  },
  (dispatch) => {
    return {
      checkUserStatus: bindActionCreators(getCredentials, dispatch),
    };
  }
)(HubStaffLoginPage);
